<template>
    <div class="trivia-title" v-if="this.selectAll == true">
        <h1>{{ title }} <span>(Select all that apply)</span></h1>
    </div>

    <div class="trivia-title" v-else>
        <h1>{{ title }}</h1>
    </div>
</template>

<script>
export default {
    name: 'trivia-title',
    props: ['title', 'selectAll'],
}
</script>


<style lang="scss" scoped>
.trivia-title {
    max-width: 90%;
}

h1 {
    font-size: 28px;
    line-height: 42px;
    text-align: left;

    span {
        font-size: 18px;
        font-style: italic;
        font-weight: normal;
    }
}
</style>
